import { motion } from 'framer-motion'
import { Heart, Twitter } from 'lucide-react'
import { useLanguage } from '@/context/LanguageContext'
import { MapleLeaf } from '@/components/ui/MapleLeaf'

export function Footer() {
  const { t, language } = useLanguage()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="relative py-16 border-t border-slate-800/50">
      <div className="absolute inset-0 bg-midnight-950" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          {/* Top Section */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-12">
            {/* Logo & Tagline */}
            <div className="text-center md:text-left">
              <motion.a
                href="/"
                className="flex items-center gap-2 justify-center md:justify-start mb-4"
                whileHover={{ scale: 1.02 }}
              >
                <div className="w-10 h-10 bg-gradient-to-br from-gold-400 to-gold-600 rounded-xl flex items-center justify-center shadow-lg shadow-gold-500/20">
                  <span className="text-midnight-950 font-bold text-xl">T</span>
                </div>
                <span className="font-bold text-xl text-slate-100">
                  Tracker<span className="text-gold-400">Capital</span>
                </span>
              </motion.a>
              <p className="text-slate-400 max-w-xs">
                {t.footer.tagline}
              </p>
            </div>

            {/* Social Links */}
            <div className="flex items-center gap-4">
              <a
                href="https://x.com/tracker_capital"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-midnight-800 border border-slate-700/50 flex items-center justify-center text-slate-400 hover:text-gold-400 hover:border-gold-500/50 transition-all"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Divider */}
          <div className="section-divider mb-8" />

          {/* Bottom Section */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            {/* Copyright */}
            <p className="text-sm text-slate-500 text-center md:text-left">
              {t.footer.copyright.replace('{year}', currentYear.toString())}
            </p>

            {/* Links */}
            <div className="flex items-center gap-6">
              <a
                href="/privacy"
                className="text-sm text-slate-500 hover:text-gold-400 transition-colors"
              >
                {t.footer.links.privacy}
              </a>
              <a
                href="/terms"
                className="text-sm text-slate-500 hover:text-gold-400 transition-colors"
              >
                {t.footer.links.terms}
              </a>
              <a
                href="mailto:hello@trackercapital.ca"
                className="text-sm text-slate-500 hover:text-gold-400 transition-colors"
              >
                {t.footer.links.contact}
              </a>
            </div>

            {/* Made in Canada */}
            <div className="flex items-center gap-2 text-sm text-slate-500">
              <span>{language === 'fr' ? 'Fait avec' : 'Made with'}</span>
              <Heart className="w-4 h-4 text-maple-500 fill-current" />
              <span>{language === 'fr' ? 'au Canada' : 'in Canada'}</span>
              <MapleLeaf className="w-4 h-4 text-maple-500" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
